import { useLevelsToSelect } from 'store/level';
import { DocumentationTranslationKeys } from 'intl/keys';
import { LabelledEntity } from 'shared/types/commonView';
import { sortByProp } from 'helpers/sort';
import { createEntityFilterInput } from '../common';

export const LevelFilterInput = createEntityFilterInput({
  useData: () => {
    const { levels } = useLevelsToSelect();
    return levels;
  },
  transformData: (levels) => {
    const available = levels.reduce<LabelledEntity[]>((acc, level) => {
      if (!level.deleted) {
        acc.push({
          _id: level._id,
          label: level.label,
          group: level.siteLabel || '',
        });
      }
      return acc;
    }, []);

    return sortByProp(available, 'group') as LabelledEntity[];
  },
  labelId: DocumentationTranslationKeys.columnLabelLevel,
  id: 'level-filter',
  groupBy: (option: LabelledEntity) => option.group || '',
});
